import React from 'react';

const PageSubTitle = ({ title }) => (
  <div className="my-1">
    <h2 className="text-gray-100 font-bold text-base">
      {title}
    </h2>
  </div>
);

export default PageSubTitle;